<app-widget-option [categories]="['INDICATORS']" [label]="'CLONE'">
  <div app-widget-option-content>
   <button mdbBtn (click)="onClone()" type="button" color="light" size="sm" class="px-2 z-depth-0 m-0" mdbWavesEffect>
      <i class="fas fa-clone fa-fw text-default"></i>
    </button>
  </div>
</app-widget-option>